import type { CSSProperties } from 'react';
import { COVER_ART, COVER_DOT, coverColors } from '../lib/cover.ts';

interface CoverProps {
  hue: number;
  /** Width/height in px; height defaults to width (1:1). */
  size: number;
  height?: number;
  radius: number;
  className?: string;
  style?: CSSProperties;
}

/** Story cover — design/Cover.dc.html. Decorative (aria-hidden): the title is always nearby. */
export function Cover({ hue, size, height, radius, className, style }: CoverProps) {
  const { c1, c2 } = coverColors(hue);
  return (
    <div
      aria-hidden="true"
      className={className}
      style={{
        width: size,
        height: height ?? size,
        borderRadius: radius,
        overflow: 'hidden',
        position: 'relative',
        flexShrink: 0,
        background: `linear-gradient(160deg, ${c1} 0%, ${c2} 100%)`,
        ...style,
      }}
    >
      <svg
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', display: 'block' }}
      >
        {COVER_ART.map((p) => (
          <path key={p.d} d={p.d} fill="#FFFFFF" fillOpacity={p.o} />
        ))}
        <circle
          cx={COVER_DOT.cx}
          cy={COVER_DOT.cy}
          r={COVER_DOT.r}
          fill="#FFFFFF"
          fillOpacity={COVER_DOT.o}
        />
      </svg>
    </div>
  );
}
